import { useState, useEffect } from "react";

/**
 * Custom hook to detect screen width breakpoints.
 * @param query - CSS media query string (e.g. "(max-width: 1024px)")
 * @returns boolean - true if the condition matches, false otherwise
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query).matches;
    }
    return false; // Default to false for SSR compatibility
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQueryList = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQueryList.matches);

    // Add event listener
    mediaQueryList.addEventListener("change", handleChange);
    
    // Set initial value
    setMatches(mediaQueryList.matches);

    // Cleanup function
    return () => {
      mediaQueryList.removeEventListener("change", handleChange);
    };
  }, [query]);

  return matches;
}
